module.exports = __webpack_public_path__ + "media/application/images/svgs/corner-left-up-64ff488b785f4c2b01aaa4b6150210d7.svg";